import { useAuthStore } from 'stores/useAuthStore';

export function usePermissions() {
  const authStore = useAuthStore();

  function canAccess(resource: string): boolean {
    return authStore.canAccess(resource);
  }

  function canAccessAny(...resources: string[]): boolean {
    return resources.some((r) => authStore.canAccess(r));
  }

  return { canAccess, canAccessAny };
}
